<template>
    <div class="content">
        <div class="section">
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../assets/img/btzs-icon.png" />
                    <span>团队基础信息</span>
                </div>
                <!-- <img src="../assets/img/icon-left.svg">
				<span>团队基础信息</span>
				<img src="../assets/img/icon-right.svg"> -->
            </div>
            <div class="baseInfo">
                <div class="nav flex-row">
                    <div
                        class="nav-item"
                        :class="currentTab == 0 ? 'activeNav' : ''"
                        @click="changeNav(0)"
                    >
                        学校
                    </div>
                    <div
                        class="nav-item"
                        :class="currentTab == 1 ? 'activeNav' : ''"
                        @click="changeNav(1)"
                    >
                        其他机构
                    </div>
                    <!--					<div class="nav-item" :class="currentTab==2?'activeNav':''" @click="changeNav(2)">-->
                    <!--						企事业单位-->
                    <!--					</div>-->
                </div>
                <div class="Inputbox flex-row">
                    <div class="info">
                        <div class="item flex-row" v-if="currentTab == 0">
                            <span>学校名称</span>
                            <el-input type="text" placeholder="请输入学校名称" v-model="schoolName">
                            </el-input>
                        </div>
                        <div class="item flex-row" v-if="currentTab == 1">
                            <span>名称</span>
                            <el-input type="text" placeholder="请输入名称" v-model="lvsName">
                            </el-input>
                        </div>
                        <div class="item flex-row" v-if="currentTab == 2">
                            <span>单位名称</span>
                            <el-input type="text" placeholder="请输入单位名称" v-model="unitName">
                            </el-input>
                        </div>
                        <div class="item flex-row">
                            <span class="code">统一社会信用代码</span>
                            <el-input
                                type="text"
                                placeholder="请输入统一社会信用代码"
                                v-model="code"
                            >
                            </el-input>
                        </div>
                        <div class="item flex-row">
                            <span>经办人员</span>
                            <el-input type="text" placeholder="请输入经办人姓名" v-model="name">
                            </el-input>
                        </div>
                    </div>
                    <div class="info">
                        <div class="item flex-row">
                            <span>电子邮箱</span>
                            <el-input type="text" placeholder="请输入电子邮箱" v-model="email">
                            </el-input>
                        </div>
                        <div class="item flex-row">
                            <span>联系电话</span>
                            <el-input type="text" placeholder="请输入联系电话" v-model="phone">
                            </el-input>
                        </div>
                        <div class="item flex-row">
                            <span>联系地址</span>
                            <el-input type="text" placeholder="请输入联系地址" v-model="address">
                            </el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../assets/img/btzs-icon.png" />
                    <span>团队认证文件</span>
                </div>
            </div>
            <div class="CertificationFile">
                <div class="upload flex-row">
                    <el-upload
                        class="upload-demo"
                        :action="uploadUrl"
                        :headers="headerObj"
                        accept=".jpg,.png,"
                        :on-success="uploadCodeSuccess"
                        ref="uploadCode"
                        :multiple="false"
                        :show-file-list="false"
                        :limit="1"
                    >
                        <div class="item flex-column" v-if="codeUrl == ''">
                            <img src="../assets/img/icon-idCard.svg" />
                            <span>{{
                                currentTab == 1
                                    ? "点击上传营业执照照片"
                                    : "点击上传统一信用代码照片"
                            }}</span>
                        </div>
                        <img v-else class="item" :src="codeUrl" />
                    </el-upload>
                    <el-upload
                        class="upload-demo"
                        ref="uploadFile"
                        :action="uploadUrl"
                        :headers="headerObj"
                        accept=".jpg,.png,"
                        :on-success="uploadFileSuccess"
                        :multiple="false"
                        :show-file-list="false"
                        :limit="1"
                    >
                        <div class="item flex-column" v-if="fileUrl == ''">
                            <img src="../assets/img/icon-letter.svg" />
                            {{
                                currentTab == 0
                                    ? "点击上传学校介绍信"
                                    : currentTab == 1
                                    ? "点击上传旅行社经营许可证"
                                    : "点击上单位经营许可证"
                            }}
                            <div v-if="currentTab == 0">（须加盖学校公章）</div>
                        </div>
                        <img v-else class="item" :src="fileUrl" />
                    </el-upload>
                </div>
                <!--				<div class="download flex-row">
					<img src="../assets/img/icon-download.svg">
					<span>下载模板</span>
				</div>-->
                <!-- <router-link to="Review"> -->
                <div class="confirm" @click="UpdateTeamAttestation" v-if="isUpdate">确认提交</div>
                <div class="confirm" @click="TeamAttestation" v-if="!isUpdate">确认提交</div>
                <!-- </router-link> -->
            </div>
        </div>
    </div>
</template>

<script>
import tool from "@/utils/tools";
import {
    login,
    TeamAttestation,
    merchantNo,
    BaseUrl,
    UpdateTeamAttestation,
} from "../utils/http.js";
name: "TeamInfo";
export default {
    data() {
        return {
            headerObj: {
                Authorization: localStorage.getItem("token"),
            }, //请求头
            uploadUrl: `${BaseUrl}/api-cms/file/upload`, //接口请求地址
            currentTab: 0,
            schoolName: "",
            unitName: "",
            code: "",
            email: "",
            phone: "",
            name: "",
            address: "",
            codeUrl: "",
            fileUrl: "",
            codeName: "",
            fileName: "",
            lvsName: "",
            id: "",
            isUpdate: false,
        };
    },
    mounted() {
        // let skey = this.$route.query.skey;
        // if (skey) {
        // 	this.skey = skey;
        // }
        // let token = tool.getStore("token")
        // if (token == null) {
        // 	this.login();
        // }
    },
    // 被 keep-alive 缓存的组件激活时调用。
    activated() {
        // 重新提交认证信息时会传递该参数
        let info = this.$route.params.info;
        if (info) {
            this.currentTab = info.teamType;
            this.schoolName = info.teamType == 0 ? info.teamName : "";
            this.unitName = info.teamType == 2 ? info.teamName : "";
            this.lvsName = info.teamType == 1 ? info.teamName : "";
            this.code = info.creditCode;
            this.email = info.email;
            this.phone = info.contactNumber;
            this.name = info.contact;
            this.address = info.address;
            this.codeUrl = info.businessLicenseUrl;
            this.fileUrl = info.permitOperation;
            this.isUpdate = this.$route.params.isUpdate;
            this.id = info.id;
        }
    },
    methods: {
        changeNav(val) {
            this.currentTab = val;
        },
        // 重新提交团队认证
        UpdateTeamAttestation() {
            if (this.schoolName == "" && this.currentTab == 0) {
                this.$message({
                    message: "请填写学校名称！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.lvsName == "" && this.currentTab == 1) {
                this.$message({
                    message: "请填写旅行社名称！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.unitName == "" && this.currentTab == 2) {
                this.$message({
                    message: "请填写单位名称！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.code == "") {
                this.$message({
                    message: "请填写信用代码！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.email == "") {
                this.$message({
                    message: "请填写电子邮箱！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.phone == "") {
                this.$message({
                    message: "请填写联系电话！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.name == "") {
                this.$message({
                    message: "请填写经办人姓名！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.address == "") {
                this.$message({
                    message: "请填写联系地址！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.codeUrl == "") {
                this.$message({
                    message: "请上传统一信用代码照片！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.fileUrl == "") {
                this.$message({
                    message: this.currentTab == 0 ? "请上传学校介绍信！" : "请上传单位公函！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            let param = {
                contact: this.name,
                contactNumber: this.phone,
                teamType: this.currentTab,
                email: this.email,
                merchantNo: merchantNo,
                creditCode: this.code,
                permitOperation: this.fileUrl,
                businessLicenseUrl: this.codeUrl,
                teamName:
                    this.currentTab == 0
                        ? this.schoolName
                        : this.currentTab == 1
                        ? this.lvsName
                        : this.unitName,
                address: this.address,
                id: this.id,
            };
            UpdateTeamAttestation(param).then(res => {
                this.$router.push("Review");
            });
        },
        // 团队认证
        TeamAttestation() {
            if (this.schoolName == "" && this.currentTab == 0) {
                this.$message({
                    message: "请填写学校名称！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.lvsName == "" && this.currentTab == 1) {
                this.$message({
                    message: "请填写旅行社名称！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.unitName == "" && this.currentTab == 2) {
                this.$message({
                    message: "请填写单位名称！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.code == "") {
                this.$message({
                    message: "请填写信用代码！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.email == "") {
                this.$message({
                    message: "请填写电子邮箱！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.phone == "") {
                this.$message({
                    message: "请填写联系电话！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.name == "") {
                this.$message({
                    message: "请填写经办人姓名！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.address == "") {
                this.$message({
                    message: "请填写联系地址！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.codeUrl == "") {
                this.$message({
                    message: "请上传统一信用代码照片！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.fileUrl == "") {
                this.$message({
                    message:
                        this.currentTab == 0
                            ? "请上传学校介绍信！"
                            : this.currentTab == 1
                            ? "请上传旅行社经营许可证！"
                            : "请上传单位经营许可证！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            let param = {
                contact: this.name,
                contactNumber: this.phone,
                teamType: this.currentTab,
                email: this.email,
                merchantNo: merchantNo,
                creditCode: this.code,
                permitOperation: this.fileUrl,
                businessLicenseUrl: this.codeUrl,
                teamName:
                    this.currentTab == 0
                        ? this.schoolName
                        : this.currentTab == 1
                        ? this.lvsName
                        : this.unitName,
                address: this.address,
            };
            TeamAttestation(param).then(res => {
                this.$router.push("Review");
            });
        },
        login() {
            let param = {
                merchantNo: merchantNo,
                appId: "f780ea5b76544c1fa20da8048f1dd424",
                skey: this.skey,
            };
            login(param).then(res => {
                tool.setStore("token", res.token);
                tool.setStore("uid", res.uid);
            });
        },
        // 统一信用代码照片上传成功
        uploadCodeSuccess(response, file, fileList) {
            //上传成功之后清除历史记录
            this.$refs.uploadCode.clearFiles();
            if (response.code == 0) {
                this.codeUrl = response.resPath;
                this.codeName = response.originalFilename;
            } else {
                this.$message({
                    message: response.msg,
                    type: "error",
                    offset: "400",
                });
            }
        },

        // 介绍信或公函照片上传成功
        uploadFileSuccess(response, file, fileList) {
            //上传成功之后清除历史记录
            this.$refs.uploadFile.clearFiles();
            if (response.code == 0) {
                this.fileUrl = response.resPath;
                this.fileName = response.originalFilename;
            } else {
                this.$message({
                    message: response.msg,
                    type: "error",
                    offset: "400",
                });
            }
        },
    },
};
</script>

<style scoped>
.content {
    width: 1200px;
    height: 778px;
    background: #fff;
    background-size: 100% 100%;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    margin: auto;
    padding: 24px;
    box-sizing: border-box;
}

.baseInfo {
    padding: 0 60px;
    box-sizing: border-box;
}

.baseInfo .nav-item {
    padding: 0 36px;
    height: 40px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #999999;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #999999;
    margin-right: 18px;
    line-height: 40px;
    margin-bottom: 24px;
    cursor: pointer;
}

/* nav激活样式 */
.activeNav {
    background: #bb2916 !important;
    border: none !important;
    color: #fff !important;
}

.Inputbox {
    justify-content: space-between;
}

.info .item {
    margin-bottom: 16px;
    text-align: right;
}

.info .item span {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333;
    margin-right: 14px;
    width: 140px;
    display: block;
    text-align: right;
}

.info .item span::before {
    content: "*";
    color: #af0b0b;
    font-size: 16px;
}

.CertificationFile {
    padding: 0 60px;
    box-sizing: border-box;
    position: relative;
}

.CertificationFile .upload {
    justify-content: space-between;
}

.CertificationFile .upload .item {
    width: 492px;
    height: 252px;
    background: #f5f5f5;
    border-radius: 6px;
    border: 1px solid #e9e9e9;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
}

.upload .item img {
    width: 82px;
    height: 82px;
    margin-bottom: 10px;
}

.CertificationFile .confirm {
    width: 324px;
    height: 60px;
    background: #ba2a17;
    border-radius: 30px;
    line-height: 60px;
    text-align: center;
    font-size: 22px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin: auto;
    margin-top: 40px;
}

.download {
    position: absolute;
    top: -36px;
    right: 60px;
}

.download span {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #e9d095;
    text-decoration: underline;
    /*文字添加下划线*/
}

.download img {
    width: 18px;
    height: 18px;
    margin-right: 6px;
}

/deep/ .item .el-input {
    width: 350px;
    height: 40px;
}

/deep/ .item .el-input__inner {
    width: 350px;
    height: 40px;
    background: #fafafa;
    border: 1px solid #e9e9e9;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}
</style>
